import React from "react";
import { Hammer } from "lucide-react";

export default function Restauracion() {
  return (
    <section id="restauracion" className="py-20 md:py-24 bg-cream relative overflow-hidden" data-testid="restauracion-section">
      <div className="container-tight relative">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full border border-wood/30 text-wood mb-6">
            <Hammer size={22} strokeWidth={1.5} />
          </div>
          <p className="label-eyebrow text-wood mb-4">Oficio</p>
          <h2 className="font-heading text-3xl md:text-4xl leading-tight text-navy" data-testid="restauracion-title">
            Restauración y cuidado.
          </h2>
          <p className="mt-7 space-y-5 text-navy/80 text-lg leading-relaxed">
            El Zorba ha sido restaurado con respeto por su historia, sus materiales y su carácter original. La madera, la cubierta, la cabina y cada detalle han sido cuidados para conservar la esencia de un velero clásico, sin renunciar a la seguridad y funcionalidad necesarias para navegar hoy.
          </p>
          <p className="mt-6 text-navy font-medium italic text-lg leading-relaxed">
            No buscamos ofrecer un barco cualquiera, sino una experiencia con alma: la de subir a bordo de una embarcación viva, cuidada y con historia.
          </p>
        </div>

        <div className="mt-14 h-px bg-gradient-to-r from-transparent via-wood/30 to-transparent" />
      </div>
    </section>
  );
}
